
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organisationId]",
      function () {
        return require("private-next-pages/[organisationId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organisationId]"])
      });
    }
  